<template>
  <div class="skillTopic assessment-mb interestTopic" :class="{'skillTopicPC':$store.state.innerWidth>768}">
    <div class="topic-pc">
     <div class="topic-content">
        <div class="skillTitle Medium">{{$t('message.Interest-Career Quiz')}}</div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth>768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
        <div class="relative">
          <div class="paginationGroup">
            <div class="swiper-pagination" slot="pagination">
            </div>
            <div class="paginationImg" >
              <img  src="../images/assessment/assessment-52.png" ref="assessmentImg"/>
            </div>
          </div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth<=768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
          <swiper :options="swiperOption" class="swiperCarrousel" ref="honorSwiper">
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping" v-for="(question,index) in questionList">                 
                  <div class="questionTip Medium center">
                     {{$store.getters.getObject(question.langData).question}}
                  </div>
                  <div class="questionTitle SemiBold center">
                     {{$store.getters.getObject(question.langData).questionHalf}}
                  </div>
                  <div class="questionImage center">
                    <img :class="[question.value>=(index+1)?'activeImg':'inactiveImg']" v-for="(img,index) in question.image"  :src="img"  />
                  </div>
                  <div class="selectTip center Medium mainColor">
                     <span class="" v-if="question.value==(index+1)" v-for="(answer,index) in question.answers">
                      {{$store.getters.getObject(answer.langData).answer}}
                     </span>
                  </div>
                  <div class="starGroup">
                    <div class="starItem item-table">
                      <div class="star tdcell" @click="changeValue(question,1)">
                        <img src="../images/assessment/input0.png" />
                        <img class="yStar" :class="{'active':question.value>=1}" src="../images/assessment/input.png" />
                      </div>
                      <div class="star tdcell" @click="changeValue(question,2)">
                        <img src="../images/assessment/input0.png" />
                        <img class="yStar" :class="{'active':question.value>=2}" src="../images/assessment/input.png" />
                      </div>
                      <div class="star tdcell" @click="changeValue(question,3)">
                        <img src="../images/assessment/input0.png" />
                        <img class="yStar" :class="{'active':question.value>=3}" src="../images/assessment/input.png" />
                      </div>
                      <div class="star tdcell" @click="changeValue(question,4)">
                        <img src="../images/assessment/input0.png" />
                        <img class="yStar" :class="{'active':question.value>=4}" src="../images/assessment/input.png" />
                      </div>
                      <div class="star tdcell" @click="changeValue(question,5)">
                        <img src="../images/assessment/input0.png" />
                        <img class="yStar" :class="{'active':question.value>=5}" src="../images/assessment/input.png" />
                      </div>
                    </div>
                  </div>
              </swiper-slide>
          </swiper>
          <div class="SkipShow center SemiBold mainColor"  v-if="occupationsList.length>0">
            <span class="pointer" role="button" :aria-label="$t('message.Show result')" @click="gotoMatches"><a href="javascript:;" style="color: inherit">{{$t('message.Show result')}}</a></span>
          </div>
          <div style="height:18px;width:100%;" v-else>
          </div>
          <div class="swiper-button-prev"  slot="button-prev">
            <a href="javascript:;" style="color: inherit"><i class="icon-arrow-down"></i></a>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <a href="javascript:;" style="color: inherit"><i class="icon-arrow-down"></i></a>
          </div>
          <div class="showResultBtn " v-if="swiperIndex==questionList.length"  @click="gotoMatches" :class="{'show':swiperIndex==questionList.length}">
            <span class="pointer"><a href="javascript:;" style="color: inherit">{{$t('message.Show result')}}</a></span>
          </div>
        </div>
     </div>
     <div class="">
        <div class="matches">
           <div class="matchesTitle SemiBold mainColor">
              {{$t('message.Your Career Matches')}}
           </div>
           <div class="matchesTip" v-if="occupationsList.length==0">
            {{$t('message.resultTip')}}
           </div>
           <div class="o-List row">
             <div class="o-box col-xs-6 col-sm-4" v-for="(occupation, index) in occupationsList">
               <div class="box" @click="goOccupationDetail(occupation)">
                 <div class="o-title Bold">
                   <span class="fourline-box wrap2">
                    <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(occupation.title)}}</a>
                   </span>
                 </div>
                   <img class="img1 noSelect" v-if="index%3==0" src="../images/deco-19.png" />
                   <img class="img2 noSelect" v-if="index%3==1" src="../images/O green1 copy.png" />
                   <img class="img3 noSelect" v-if="index%3==2" src="../images/Vector Smart Object2.png" />
               </div>
             </div>
           </div>
        </div>
     </div>
     <div class="bgImage">
       <img class="bgImg2 noSelect" src="../images/deco-05.png" />
       <img class="bgImg3 noSelect" src="../images/deco-14.png" />
       <img class="bgImg4 noSelect" src="../images/deco-12.png" />
       <img class="bgImg5 noSelect" src="../images/deco-31.png" />
     </div>
     </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            swiperOption: {
                pagination: {
                  el: '.swiper-pagination',
                  type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on:{
                  transitionEnd: this.transitionEnd,
                  transitionStart: this.transitionStart,
                },
            },
            questionList:[],
            occupationsList:[],
            totalRows:0,
            value:1,
            swiperIndex:1,
            answerIndex:0,
            getQuestions:false,
            marks: val => val % 1 === 0,
        }
    },   
    props: ["logGaEvent"],
    components: {
    },
    created(){
    },
    computed: {
      __swiper__() {
        if(this.questionList.length>0)
        return this.$refs.honorSwiper.swiper
      }
    },
    methods: {
      init:function(){
        var that = this;
        this.api.getInterestQuestionList({
        }, function(data) {
            for(var i=0;i<data.result.length;i++){
              data.result[i].value=3;
              data.result[i].image = [
                require("@/images/assessment/interest-1.png"),
                require("@/images/assessment/interest-2.png"),
                require("@/images/assessment/interest-3.png"),
                require("@/images/assessment/interest-4.png"),
                require("@/images/assessment/interest-5.png"),
              ];
            }
            that.totalRows = data.totalRows;
            that.$set(that, "questionList", data.result);
            that.transitionStart()
        })
      },
      transitionEnd:function(){
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
        var scoreData = []
        if(this.swiperIndex>6){
          for(var i=0;i<this.swiperIndex-1;i++){
            scoreData.push({
              "code":this.questionList[i].code,
              "score":this.questionList[i].value,
            })
          }
          // scoreData = this.checkScoreData(scoreData);
          this.getInterestOccupationList(scoreData)
        }else{
          this.occupationsList = [];
        }
          this.logGaEvent('userClick','InterestAssessmentTopic-transitionEnd',this.swiperIndex)
      },
      checkScoreData:function(scoreData){
          var is1=true;
          var is2=true;
          var is3=true;
          var is4=true;
          var is5=true;
          if(this.swiperIndex == this.questionList.length){
            for(var i=0;i<scoreData.length;i++){
              if(scoreData[i].score!=1){
                is1 = false;
              }
              if(scoreData[i].score!=2){
                is2 = false;
              }
              if(scoreData[i].score!=3){
                is3 = false;
              }
              if(scoreData[i].score!=4){
                is4 = false;
              }
              if(scoreData[i].score!=5){
                is5 = false;
              }
            }
            if(is1||is2||is3||is4||is5){
              scoreData.splice(scoreData.length-1,1);
            }
          }
          return scoreData;
      },
      changeValue:function(obj,val){
        obj.value=0;
        setTimeout(function(){
          obj.value = val;
        })
        
      },
      transitionStart:function(){
        if(this.$store.state.innerWidth>840){
          var w = 840 - 70;
        }else{
          var w = this.$store.state.innerWidth - 70;
        }
        
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        var left = w/this.totalRows*(this.__swiper__.activeIndex+1) -5;
        this.$refs.assessmentImg.style.transform = "translate3d("+ left +"px, 0px, 0px) "
        
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
      },
      getInterestOccupationList:function(scoreData){
        let Base64 = require('js-base64').Base64;
        var that = this;
        this.api.getInterestOccupationList({
          "scoreData":Base64.encode(JSON.stringify(scoreData))
        }, function(data) {
            // that.totalRows = data.totalRows;
            that.$set(that, "occupationsList", data.result);
        })
      },
      gotoMatches:function(){
        var scoreData = []
        if(this.swiperIndex>=6){
          for(var i=0;i<this.swiperIndex;i++){
            scoreData.push({
              "code":this.questionList[i].code,
              "score":this.questionList[i].value,
            })
          }
          // scoreData = this.checkScoreData(scoreData);
          this.$store.state.formData.scoreData = scoreData;
          this.$store.state.formData.scoreType = 2;
          this.logGaEvent('userClick','InterestAssessmentTopic-gotoMatches',this.swiperIndex);
          this.$router.push({ path: '/careerMatches/' , query:{lang:this.$store.state.language}});
           window.scrollTo(0, 0);
        }
      },
      goOccupationDetail:function(item){
        this.logGaEvent('userClick','InterestAssessmentTopic-goOccupationDetail',item.id);
        // this.$router.push({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}})
        //  window.scrollTo(0, 0);

        let routeData = this.$router.resolve({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}});
        window.open(routeData.href, '_blank');
      }
    },
    mounted() {
      this.$store.state.selectMenu =5;
      this.$store.state.formData.scoreData = [];
      this.$store.state.formData.scoreType = 0;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
      this.init()
    },
    watch:{
      questionList: {
        handler: function(val, oldVal) {
          for(var i=0;i<this.questionList.length;i++){
          }
        },
        deep: true
      }
    }
}
</script>